import { render, staticRenderFns } from "./Yesterday.vue?vue&type=template&id=de897da0"
import script from "./Yesterday.vue?vue&type=script&lang=js"
export * from "./Yesterday.vue?vue&type=script&lang=js"
import style0 from "./Yesterday.vue?vue&type=style&index=0&id=de897da0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports